module.exports = __webpack_public_path__ + "static/PlutoSansCondRegular-954cdab2885eb6394f205e6385e61245.ttf";